import React from 'react'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import { Button } from '../styles'

const SecondaryButton = ({
  onClick, children, disabled, style
}) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    color={colors.strongGray}
    backgroundcolor={colors.grayBackground}
    style={style}
  >
    {children}
  </Button>
)

SecondaryButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.shape({}),
}

SecondaryButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  style: null,
}

export default SecondaryButton
